import { AccessTokenService } from '@cbsi-cbscom/auth-suite-sdk';

export default class AuthSuiteAccessTokenService {
    constructor() {
        this.accessTokenService = new AccessTokenService();
    }

    getAccessToken = () => this.accessTokenService.getAccessToken();
}
